/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-vars */

xplenty.directive('datePicker', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('../../../views/directives/date-picker.html'),

      replace: true,

      scope: {
        date: '=ngModel',
      },

      link(scope, element, attrs) {
        const $input = element.find('input');
        const format = attrs.format || 'MMM DD, YYYY';

        element
          .datetimepicker({
            format,
            date: moment(scope.date),
            icons: {
              time: 'fa fa-clock-o',
              date: 'fa fa-calendar',
              up: 'fa fa-arrow-up',
              down: 'fa fa-arrow-down',
              next: 'fa fa-arrow-right',
              previous: 'fa fa-arrow-left',
            },
          })
          .on('dp.change', function (e) {
            if (e.date) {
              scope.date.day = e.date.date();
              scope.date.month = e.date.month();
              scope.date.year = e.date.year();
              scope.$parent.$apply();
            } else {
              $(e.target).data('DateTimePicker').date(moment(scope.date).format(format));
            }
          });
      },
    };
  },
]);
